import { Button, Stack, Typography } from "@mui/material";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { DialogContainer, DialogHeader } from "../../components/exports";
import { DialogContext } from "../../contexts/DialogContext";

export default function UserPolicyNotice(props: { userCount: number; isOwner: boolean }) {
    const { closeDialog } = useContext(DialogContext);
    const navigate = useNavigate();

    const manageUsers = () => {
        closeDialog();
        navigate("/users");
    };

    return (
        <DialogContainer preferredWith={450}>
            <DialogHeader title="تغییر سیاست دسترسی کاربران" />
            <Stack spacing={2} sx={{ p: 2 }}>
                <Typography>
                    سیاست دسترسی کاربران تغییر کرده است. حداکثر ۳ کاربر، با احتساب صاحب حساب، می‌توانند دسترسی فعال داشته باشند.
                </Typography>
                <Typography fontWeight="bold">
                    از تاریخ ۱ آبان ۱۴۰۵، ورود کاربران مازاد بر ظرفیت مجاز به برنامه مسدود خواهد شد.
                </Typography>
                <Typography>
                    حساب شما {props.userCount} کاربر دارد.
                    {" "}{props.isOwner
                        ? "لطفاً پیش از این تاریخ در بخش مدیریت کاربران، دسترسی کاربران موردنیاز را فعال و دسترسی سایر کاربران را غیرفعال کنید."
                        : "لطفاً پیش از این تاریخ برای مدیریت دسترسی کاربران با صاحب حساب تماس بگیرید."}
                </Typography>
                <Typography color="text.secondary">
                    برای فعال کردن کاربر جدید در صورت تکمیل ظرفیت، ابتدا یکی از کاربران فعال را غیرفعال کنید.
                </Typography>
                <Stack direction="row" spacing={1} justifyContent="flex-end">
                    <Button onClick={() => closeDialog()}>متوجه شدم</Button>
                    {props.isOwner && (
                        <Button variant="contained" onClick={manageUsers}>مدیریت کاربران</Button>
                    )}
                </Stack>
            </Stack>
        </DialogContainer>
    );
}
